import { RenderResult, ByRoleMatcher } from '@testing-library/preact';

export function getIcon(menuItem: HTMLElement, selector: string) {
  return menuItem.querySelector(selector);
}

export function getAllMenuItemsByRole(content: RenderResult, role: ByRoleMatcher, hidden = true) {
  return content.getAllByRole(role, { hidden });
}

export function getMenuItemByRole(content: RenderResult, role: ByRoleMatcher, hidden = true) {
  return content.getByRole(role, { hidden });
}

export function getLabel(content: RenderResult, label: string) {
  return content.getByText(label);
}

export function setObserverConfig() {
  if (!window.ResizeObserver) {
    // ResizeObserver isn't available in test environment
    const MockResizeObserver = jest.fn();
    MockResizeObserver.mockReturnValue({
      observe: () => null,
      unobserve: () => null,
      disconnect: () => null
    });

    Object.defineProperty(global, 'ResizeObserver', {
      writable: true,
      configurable: true,
      value: MockResizeObserver
    });
  }
}
